<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <span>Bildirim Ayarlari</span>
            <v-btn
              color="success"
              @click="saveConfig"
              :loading="saving"
              :disabled="saving"
            >
              <v-icon left>mdi-content-save</v-icon>
              Kaydet
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <!-- Alert -->
    <v-row v-if="alert.show">
      <v-col cols="12">
        <v-alert :type="alert.type" dismissible @click:close="alert.show = false">
          {{ alert.message }}
        </v-alert>
      </v-col>
    </v-row>

    <v-row>
      <!-- Email Configuration -->
      <v-col cols="12" md="6">
        <v-card elevation="4" class="config-card">
          <v-card-title class="config-card-title">
            <v-icon left>mdi-email-outline</v-icon>
            Email Yapilandirmasi
            <v-spacer></v-spacer>
            <v-switch
              v-model="config.email_enabled"
              color="success"
              hide-details
              density="compact"
            ></v-switch>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="config.smtp_host"
                  label="SMTP Host"
                  placeholder="smtp.gmail.com"
                  outlined
                  dense
                  :disabled="!config.email_enabled"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="config.smtp_port"
                  label="SMTP Port"
                  type="number"
                  outlined
                  dense
                  :disabled="!config.email_enabled"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="config.smtp_user"
                  label="SMTP Kullanici"
                  outlined
                  dense
                  :disabled="!config.email_enabled"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="config.smtp_pass"
                  label="SMTP Sifre"
                  :type="showSmtpPass ? 'text' : 'password'"
                  outlined
                  dense
                  :disabled="!config.email_enabled"
                  :append-inner-icon="showSmtpPass ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append-inner="showSmtpPass = !showSmtpPass"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="config.smtp_from"
                  label="Gonderen Adresi"
                  placeholder="noreply@example.com"
                  outlined
                  dense
                  :disabled="!config.email_enabled"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="config.smtp_secure"
                  label="SSL/TLS (Guvenli Baglanti)"
                  :disabled="!config.email_enabled"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  v-model="config.email_recipients"
                  label="Alici E-posta Adresleri"
                  multiple
                  chips
                  closable-chips
                  outlined
                  dense
                  :disabled="!config.email_enabled"
                  hint="E-posta adresini yazin ve Enter'a basin"
                  persistent-hint
                ></v-combobox>
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="info"
                  variant="outlined"
                  @click="testEmail"
                  :loading="testingEmail"
                  :disabled="!config.email_enabled || testingEmail"
                  block
                >
                  <v-icon left>mdi-email-send-outline</v-icon>
                  Test Email Gonder
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Telegram Configuration -->
      <v-col cols="12" md="6">
        <v-card elevation="4" class="config-card">
          <v-card-title class="config-card-title">
            <v-icon left>mdi-send</v-icon>
            Telegram Yapilandirmasi
            <v-spacer></v-spacer>
            <v-switch
              v-model="config.telegram_enabled"
              color="success"
              hide-details
              density="compact"
            ></v-switch>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="config.telegram_bot_token"
                  label="Bot Token"
                  placeholder="123456789:ABCdefGHIjklMNOpqrsTUVwxyz"
                  :type="showBotToken ? 'text' : 'password'"
                  outlined
                  dense
                  :disabled="!config.telegram_enabled"
                  :append-inner-icon="showBotToken ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append-inner="showBotToken = !showBotToken"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  v-model="config.telegram_chat_ids"
                  label="Chat ID'leri"
                  multiple
                  chips
                  closable-chips
                  outlined
                  dense
                  :disabled="!config.telegram_enabled"
                  hint="Chat ID'yi yazin ve Enter'a basin"
                  persistent-hint
                ></v-combobox>
              </v-col>
              <v-col cols="12">
                <v-alert type="info" variant="tonal" density="compact" class="mb-4">
                  Bot token almak icin Telegram'da @BotFather'a mesaj gonderiniz.
                  Chat ID ogrenmek icin botu gruba ekledikten sonra @userinfobot kullanabilirsiniz.
                </v-alert>
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="info"
                  variant="outlined"
                  @click="testTelegram"
                  :loading="testingTelegram"
                  :disabled="!config.telegram_enabled || testingTelegram"
                  block
                >
                  <v-icon left>mdi-send</v-icon>
                  Test Mesaji Gonder
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NotificationConfig',
  data() {
    return {
      config: {
        email_enabled: false,
        smtp_host: '',
        smtp_port: 587,
        smtp_secure: false,
        smtp_user: '',
        smtp_pass: '',
        smtp_from: '',
        email_recipients: [],
        telegram_enabled: false,
        telegram_bot_token: '',
        telegram_chat_ids: []
      },
      loading: false,
      saving: false,
      testingEmail: false,
      testingTelegram: false,
      showSmtpPass: false,
      showBotToken: false,
      alert: {
        show: false,
        type: 'success',
        message: ''
      }
    }
  },
  async created() {
    await this.fetchConfig()
  },
  methods: {
    async fetchConfig() {
      this.loading = true
      try {
        const response = await this.$api.get('/api/notification-config')
        this.config = response.data
      } catch (error) {
        console.error('Error fetching notification config:', error)
        this.showAlert('error', 'Yapilandirma yuklenirken hata olustu')
      } finally {
        this.loading = false
      }
    },

    async saveConfig() {
      this.saving = true
      try {
        const response = await this.$api.put('/api/notification-config', this.config)
        this.config = response.data
        this.showAlert('success', 'Yapilandirma basariyla kaydedildi')
      } catch (error) {
        console.error('Error saving notification config:', error)
        this.showAlert('error', 'Yapilandirma kaydedilirken hata olustu')
      } finally {
        this.saving = false
      }
    },

    async testEmail() {
      this.testingEmail = true
      try {
        const response = await this.$api.post('/api/notification-config/test-email', this.config)
        this.showAlert('success', response.data.message)
      } catch (error) {
        console.error('Test email failed:', error)
        const msg = error.response?.data?.error || 'Test e-postasi gonderilemedi'
        this.showAlert('error', msg)
      } finally {
        this.testingEmail = false
      }
    },

    async testTelegram() {
      this.testingTelegram = true
      try {
        const response = await this.$api.post('/api/notification-config/test-telegram', this.config)
        this.showAlert('success', response.data.message)
      } catch (error) {
        console.error('Test telegram failed:', error)
        const msg = error.response?.data?.error || 'Test mesaji gonderilemedi'
        this.showAlert('error', msg)
      } finally {
        this.testingTelegram = false
      }
    },

    showAlert(type, message) {
      this.alert = { show: true, type, message }
    }
  }
}
</script>

<style scoped>
.config-card {
  border-radius: 12px;
  overflow: hidden;
}

.config-card-title {
  font-weight: 600;
}
</style>
